import { RowExportTypeExcel } from "types";
import { excel } from "utils";
import { InventoryTurnoverResponse } from "../../types/InventoryTurnover";
import { getTurnoverStatus } from "../../utils/hooks/useInventoryTurnover";


export function ExportExcelInventoryTurnover({ dataList, turnoverRules }: {
  dataList: InventoryTurnoverResponse['data'],
  turnoverRules: InventoryTurnoverResponse['turnover_rule'],
}) {
  const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 30 },
    { header: 'PRODUCT NAME', key: 'product_name', width: 20 },
    { header: 'BEGIN QTY', key: 'begin_qty', width: 15 },
    { header: 'END QTY', key: 'end_qty', width: 15 },
    { header: 'AVG QTY', key: 'avg_qty', width: 15 },
    { header: 'UNIT SOLD', key: 'unit_sold', width: 15 },
    { header: 'TURNOVER (QTY)', key: 'qty_turnover', width: 15 },
    { header: 'DIO (Days)', key: 'dio', width: 10 },
    { header: 'STATUS', key: 'status', width: 20 },
  ];

  const dataMap: RowExportTypeExcel[] = dataList.map((item, index: number) => {
    const rule = getTurnoverStatus(
        item.qty_turnover,
        turnoverRules
    );

    return {
      no: index + 1,
      code: item.product_barcode,
      product_name: item.product_name,
      begin_qty: {
        text: Number(item.begin_qty),
        style: {
          numFmt: '#,##0',
        }
      },
      end_qty: {
        text: Number(item.end_qty),
         style: {
          numFmt: '#,##0',
        }
      },
      avg_qty: {
        text: Number(item.avg_qty),
         style: {
          numFmt: '#,##0',
        }
      },
      unit_sold: {
        text: Number(item.unit_sold),
         style: {
          numFmt: '#,##0',
        }
      },
      qty_turnover: {
        text: Number(item.qty_turnover),
         style: {
          numFmt: '#,##0',
        }
      },
      dio: {
        text: item?.qty_turnover && item?.qty_turnover > 0 && item?.avg_qty ? `${Number( 365 / Number(item?.qty_turnover))}`:"0",
         style: {
            numFmt: '#,##0',
        }
      },
      status: rule?.mr_product_turnover_name ?? '-',
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: 'INVENTORI',
    title: 'INVENTORY TURNOVER',
    fileName: 'Inventory_Turnover',
  });
}

